import { IntegrationIcon } from "../../../IntegrationIcon";
import { ConnectionPayload } from "./ConnectionNode";

export interface ConnectionComponentProps {
  connection: ConnectionPayload;
  imageURL?: string;
}

export function ConnectionComponent({
  connection,
  imageURL,
}: ConnectionComponentProps) {
  return (
    <span className="relative text-primary pl-1">
      <IntegrationIcon
        imageURL={imageURL}
        platform={connection.platform}
        name={connection.title}
        className="inline w-[18px] h-[18px] relative top-[-2px] mr-1"
      />

      <strong>{connection.title}</strong>
    </span>
  );
}
